import React from 'react';
import { connect } from 'react-redux';
import CreateProfile from '../../../components/Sections/CreateProfile/CreateProfile';

class Register extends React.Component {
  constructor(props) {
		super(props);   
    props.dispatch({ type: 'INITIALIZE_API' }); 
     props.dispatch({ type: 'INITIALIZE_REGISTER' });   
	}
 componentWillMount() {
    const p = this.props;  
    if( p.email && p.bpNumber)
     p.dispatch({type:'textbox',  name: 'profileEmailAddress', value: p.email} );   
  }
  render() {
    const p = this.props;  
    const isInvitedFromCafe =  p.email && p.bpNumber;     
    return (
    <div className="col-md-8 col-md-offset-2">
      <div className="panel panel-default">       
        <div className="panel-body">          
          { isInvitedFromCafe? 
           <CreateProfile isRegister isInvitedFromCafe bpNumber={p.bpNumber}/>
           :
           <CreateProfile isRegister/>
          }
        </div>
      </div>
    </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    email :  state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["email"],
    bpNumber : state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["bpnumber"],
  };
}

export default connect(mapStateToProps)(Register);

